import styles from '~/styles/molecules/header/header_organaization.module.scss'

import { ChildProps } from '~/common/define/props'
import { addClass } from '~/common/utils/html'
import { MutableRefObject } from 'react'
import InternalLink from '~/components/atoms/link/InternalLink'

interface Props extends ChildProps {
  buttonRef?: MutableRefObject<any>
  onClick?(): void
  link?: string
  pull?: boolean
}

const OrganizationHeaderTextButton = ({children, buttonRef = null, onClick, link = null, pull = false}: Props) => {
  return (
    <>
      {link ?
        <InternalLink className={styles.headerOrganization__textButton + addClass(styles.rightArrow, pull)} link={link}>
          {children}
        </InternalLink> :
        onClick ?
          <button className={styles.headerOrganization__textButton + addClass(styles.rightArrow, pull)} ref={buttonRef}
                  onClick={onClick}>
            {children}
          </button> :
          <span className={styles.headerOrganization__textButton + addClass(styles.rightArrow, pull)} ref={buttonRef}>
            {children}
          </span>
      }
    </>
  )
}

export default OrganizationHeaderTextButton